import React from 'react';
import { render } from 'react-dom';
import Widget from './widget.jsx';

const renderCelebrationPreferencesWidget = ( options ) => {
    const { container } = options;

    render(
        <Widget { ...options } />, document.getElementById( container )
    );

};
window.renderCelebrationPreferencesWidget = renderCelebrationPreferencesWidget;
